import Button from '@/shared/components/Button';
import {Box, Icon, Typography} from '@mui/material';
import {ReactComponent as CheckedIcon} from '@icons/rudiobutton-checked-blue.svg';
import {FC} from 'react';
import {twoStepAuthenticationDisableStyles} from './TwoStepAuthentication.Disable.styles';

export interface TwoStepAuthenticationDisableStep2Props {
	onClose: () => void;
}
const TwoStepAuthenticationDisableStep2: FC<TwoStepAuthenticationDisableStep2Props> = ({onClose}) => {
	return (
		<Box>
			<Icon sx={twoStepAuthenticationDisableStyles.iconChecked}>
				<CheckedIcon />
			</Icon>
			<Typography sx={twoStepAuthenticationDisableStyles.title}>Two-Step Authentication Disabled</Typography>
			<Button sx={twoStepAuthenticationDisableStyles.buttonWrapper} title="Done" onClick={onClose} />
		</Box>
	);
};

export default TwoStepAuthenticationDisableStep2;
